import { useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';

type PageState = ReturnType<typeof useStartAPetitionPageState>;
type FlowId = NonNullable<NonNullable<NonNullable<PageState['data']['draft']>['metadata']>['variant']>;
type Result = ModelHookResult<{ flowId: FlowId }, { matches: PageState['actions']['matches'] }>;

export function usePageBody(): Result {
	const { data, actions } = useStartAPetitionPageState();

	return { data: { flowId: data.draft?.metadata?.variant ?? 'control' }, actions: { matches: actions.matches } };
}
